export function RamalhoLogo({ className = "", showText = true, size = 32 }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="ramalho-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <rect width="48" height="48" rx="10" fill="#1B4332" />
        {/* Sun/leaf glyph */}
        <path
          d="M24 10c0 6 4 8 8 8-4 4-8 4-8 12 0-8-4-8-8-12 4 0 8-2 8-8z"
          fill="#D8F3DC"
        />
        <circle cx="24" cy="34" r="3" fill="#D8F3DC" />
        <path d="M14 38h20" stroke="#D8F3DC" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
      {showText && (
        <div className="flex flex-col leading-none">
          <span className="font-display text-[15px] font-semibold tracking-tight text-[#1B4332]">
            Ramalho
          </span>
          <span className="text-[10px] uppercase tracking-[0.2em] text-[#52796F] mt-0.5">
            Gestão Energética
          </span>
        </div>
      )}
    </div>
  );
}
